"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = TextField;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SelectPanel = require("./SelectPanel");

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react2 = require("../..");

var _InputError = require("./InputError");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    cursor: ", ";\n    line-height: ", "px;\n    border: solid 1px ", ";\n    position: relative;\n    padding-left: ", "px;\n    padding-right: ", "px;\n    z-index: 1;           \n    outline: none;\n    font-weight: normal;\n    margin: ", ";\n    background-color: ", ";\n    &.active {\n        border-color: ", ";\n    }\n    > input, > textarea {\n        background-color: transparent;\n        line-height: ", "px;\n        outline: none;\n        width: 100%;\n        padding-bottom: 0;\n        padding-top: 0;\n   \n        font-size:  ", "rem;\n        margin-top: ", ";\n                                                                                                                                          \n        border: none;\n        &::placeholder {\n            color: ", ";\n        }\n        caret-color: ", ";\n        text-align: ", ";    \n    }\n    > .prefix, .postfix {\n        display: flex;\n        position: absolute;\n        font-size:  ", "rem;\n        padding: 0px ", "px 0px ", "px;\n        top: 0;\n        bottom: 0;\n    }\n    > .prefix {\n        left: 0;\n    }\n    > .postfix {\n        right: 0;\n    }\n    > .textbox-label {\n        color: ", ";\n        font-size: ", "rem;\n        font-weight: 600;        \n        font-family: ", ";\n        margin: ", "px;\n        margin-bottom: ", "px;\n        line-height: ", "px;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n> .input_error {\n    margin-left: ", ";\n    font-size: ", "rem;    \n    font-family: ", ";\n    text-align: left;\n    color: ", ";\n    &:empty {\n        display:none;\n    }\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var tabIndexVal = 1;
/* *********************************************************************************************************************
 Component TextBox
 ********************************************************************************************************************* */

var ErrorMessage = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.spacingObj.margin + 'px ';
}, function (props) {
  return props.spacingObj.errorFontSize;
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.colors.errorColor;
});

var TextFieldWrapper = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.disabled ? 'white' : props.hasValue ? props.active ? props.colors.activeIcon : props.colors.placeholderColor : props.colors.placeholderColor;
}, function (props) {
  return props.hasValue ? 'pointer' : 'default';
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return !!props.error ? props.colors.errorColor : props.colors.idleBorderColor;
}, function (props) {
  return props.preFixWidth ? props.spacingObj.padding + props.preFixWidth : props.spacingObj.padding;
}, function (props) {
  return props.postFixWidth > 0 ? props.spacingObj.padding + props.postFixWidth : props.spacingObj.padding;
}, function (props) {
  return (props.showSuggestions ? '0' : props.spacingObj.margin) + 'px 0';
}, function (props) {
  return props.disabled ? props.colors.idleBorderColor : null;
}, function (props) {
  return !!props.error || props.error ? props.colors.errorColor : props.colors.borderColor;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.elementType === 'textarea' ? props.spacingObj.padding + 'px' : 0;
}, function (props) {
  return props.colors.idleBorderColor;
}, function (props) {
  return props.colors.borderColor;
}, function (props) {
  return props.postfix ? 'right' : 'left';
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return 2 * props.spacingObj.padding;
}, function (props) {
  return 2 * props.spacingObj.padding;
}, function (props) {
  return props.colors.textColor;
}, function (props) {
  return props.spacingObj.labelFontSize;
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.spacingObj.padding;
}, function (props) {
  return props.spacingObj.padding * -1;
}, function (props) {
  return props.spacingObj.padding * 2;
}); //error needs to return true or false (boolean) as opposed to in my version 

/**
 * The Text Field component is used for text input. It has in-built error handling and displaying functionality.
 * 
 * @example import { TextField } from '@desktop/react'; 
 */


function TextField(props) {
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[props.type];
  var color = context.getColors()[props.type];

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = (0, _react.useState)(props.value),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      suggestionItems = _useState6[0],
      setSuggestions = _useState6[1];

  var _useState7 = (0, _react.useState)(tabIndexVal++),
      _useState8 = _slicedToArray(_useState7, 2),
      tabIndex = _useState8[0],
      setTabIndex = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = _slicedToArray(_useState9, 2),
      postFixWidth = _useState10[0],
      setPostFixWidth = _useState10[1];

  var _useState11 = (0, _react.useState)(0),
      _useState12 = _slicedToArray(_useState11, 2),
      preFixWidth = _useState12[0],
      setPreFixWidth = _useState12[1];

  var valueApplied = (0, _react.useRef)(null);
  var error = (0, _InputError.useErrorHandler)(value, props.errorRequirements, props.type);
  (0, _react.useEffect)(function () {
    getSuggestions(value);
  }, [value]);
  (0, _react.useEffect)(function () {
    setValue(props.value);
  }, [props.value]);
  (0, _react.useEffect)(function () {
    if (props.postfix) {
      setPostFixWidth(postfixRef.current.clientWidth - spacing.padding * 2);
    }
  }, [props.postfix]);
  (0, _react.useEffect)(function () {
    if (props.prefix) {
      setPreFixWidth(prefixRef.current.clientWidth - spacing.padding * 2);
    }
  }, [props.prefix]);
  var textInput = (0, _react.useRef)(null);
  var postfixRef = (0, _react.useRef)(null);
  var prefixRef = (0, _react.useRef)(null);
  var selectPanelRef = (0, _react.useRef)(null);

  var onChange = function onChange(e) {
    var val = e.target.value !== '' ? e.target.value : '';
    valueApplied.current = false;
    setValue(val);
    props.onChange(e, val);
  };

  var getSuggestions = function getSuggestions(term) {
    if (!term || props.inputType !== 'text') {
      return [];
    }

    term = term.toUpperCase();
    var results = [];
    props.suggestionData.map(function (v) {
      if (v.toUpperCase().indexOf(term) >= 0) {
        results.push({
          label: v,
          value: v
        });
      }
    });
    if (selectPanelRef.current && !valueApplied.current) selectPanelRef.current.open();
    setSuggestions(sortResults(results));
  };

  var sortResults = function sortResults(results) {
    return results.sort(function (a, b) {
      return a.code > b.code ? 1 : b.code > a.code ? -1 : 0;
    });
  };

  var applyValue = function applyValue(val, stopFocus) {
    if (val !== undefined) {
      var resval = val.value && val.value !== null ? val.value : val !== null ? val : '';
      textInput.current.value = resval;
      setValue(resval);
      valueApplied.current = true;
      selectPanelRef.current.close();

      if (!stopFocus) {
        textInput.current.focus();
      } else {
        textInput.current.parentNode.focus();
      }
    }
  };

  var onCompleteInputBlur = function onCompleteInputBlur(e) {
    setTimeout(function () {
      var target = document.activeElement;

      if (target.className !== "SelectPanel" && props.showSuggestions) {
        selectPanelRef.current.close();
        setActive(false);
      } else if (!props.showSuggestions) {
        setActive(false);
      }

      props.onBlur(value);
    }, 1);
  };

  var inputKeyPress = function inputKeyPress(e) {
    if (e.charCode === 13) {
      props.onEnterKey(value);
      textInput.current.parentNode.focus();
    }

    props.onKeyPress(e.charCode, value);
  };

  var iconNode = null;

  if (props.iconName) {
    iconNode = /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
      iconid: props.iconName,
      size: "small",
      color: props.iconColor
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TextFieldWrapper, {
    error: props.error ? props.error : error.props.children ? error : false,
    colors: color,
    spacingObj: spacing,
    className: (active ? 'active ' : '') + props.className,
    style: props.style,
    disabled: props.disabled,
    prefix: props.prefix,
    postfix: props.postfix,
    postFixWidth: postFixWidth,
    preFixWidth: preFixWidth,
    hasLabel: !!props.label,
    showSuggestions: props.showSuggestions,
    elementType: props.elementType,
    iconName: props.iconName,
    fontFamilyObj: context.getFont()
  }, props.label && /*#__PURE__*/_react["default"].createElement("p", {
    key: "label",
    className: "textbox-label"
  }, props.label), props.prefix && /*#__PURE__*/_react["default"].createElement("div", {
    ref: prefixRef,
    className: "prefix",
    style: {
      paddingLeft: spacing.padding + 'px',
      display: 'flex',
      alignSelf: 'center'
    }
  }, props.prefix, props.iconPosition === "prefix" ? iconNode : null), props.postfix && /*#__PURE__*/_react["default"].createElement("div", {
    ref: postfixRef,
    className: "postfix",
    style: {
      paddingRight: spacing.padding + 'px',
      display: 'flex',
      alignSelf: 'center'
    }
  }, props.postfix, props.iconPosition === "postfix" ? iconNode : null), props.elementType === 'input' ? /*#__PURE__*/_react["default"].createElement("input", {
    key: "input",
    ref: textInput,
    style: props.style,
    value: value,
    type: props.inputType,
    name: props.name,
    disabled: props.disabled ? 'disabled' : null,
    readOnly: props.readOnly ? 'readonly' : null,
    onClick: function onClick(e) {
      setActive(true);
      props.onClick(e);
    },
    onKeyUp: props.onKeyUp,
    onKeyPress: inputKeyPress,
    onBlur: onCompleteInputBlur,
    onChange: onChange,
    tabIndex: tabIndex,
    maxLength: props.maxLength,
    placeholder: props.placeholder,
    autoComplete: props.autoComplete
  }) : /*#__PURE__*/_react["default"].createElement("textarea", {
    key: "input",
    ref: textInput,
    style: props.style,
    value: value,
    type: props.inputType,
    name: props.name,
    disabled: props.disabled ? 'disabled' : null,
    readOnly: props.readOnly ? 'readonly' : null,
    onClick: function onClick(e) {
      setActive(true);
      props.onClick(e);
    },
    onKeyUp: props.onKeyUp,
    onKeyPress: inputKeyPress,
    onBlur: onCompleteInputBlur,
    onChange: onChange,
    tabIndex: tabIndex,
    maxLength: props.maxLength,
    placeholder: props.placeholder,
    props: true,
    autoComplete: props.autoComplete
  })), props.showSuggestions ? /*#__PURE__*/_react["default"].createElement(_SelectPanel.SuggestionsPanel, {
    key: "selectpanel",
    ref: selectPanelRef,
    items: suggestionItems,
    onSelect: applyValue,
    onClose: function onClose() {
      setActive(false);
    }
  }) : null, /*#__PURE__*/_react["default"].createElement(ErrorMessage, {
    error: props.error ? props.error : error.children,
    colors: color,
    spacingObj: spacing,
    fontFamilyObj: context.getFont(),
    style: props.errorStyle
  }, props.error ? /*#__PURE__*/_react["default"].createElement("span", {
    key: "error",
    className: "input_error"
  }, props.error) : /*#__PURE__*/_react["default"].createElement("div", {
    key: "error",
    className: "input_error"
  }, error)));
}

TextField.propTypes = {
  /**Toggle to enable and disable the TextBox input. */
  disabled: _propTypes["default"].bool,

  /**An error string that when not null, will put the input into an error state, and display this error message below the input. */
  error: _propTypes["default"].string,

  /**Will populate the type attribute on the input. This is used to designate password or number fields on the input. */
  inputType: _propTypes["default"].string,

  /**Adding a label will put the element above the input field and bind it to the input container. */
  label: _propTypes["default"].string,

  /**Will populate the name attribute on the input. Doing this helps with form auto-complete functions of the browser. */
  name: _propTypes["default"].string,

  /**Callback function that is fired when the input is blurred. */
  onBlur: _propTypes["default"].func,

  /**Callback function that is fired when the input is clicked. */
  onClick: _propTypes["default"].func,

  /**Callback function that is fired when the input's value is changed, either by user input or programatically. */
  onChange: _propTypes["default"].func,

  /**Callback function that is fired when there is a user's key press. */
  onKeyPress: _propTypes["default"].func,

  /**Callback function that is fired when the user's key releases. */
  onKeyUp: _propTypes["default"].func,

  /**The string shown when no value has been entered into the input. */
  placeholder: _propTypes["default"].string,

  /**Disables the field from accepting input, putting it into read-only format. */
  readOnly: _propTypes["default"].bool,

  /**The overriding styling of the TextField component. */
  style: _propTypes["default"].object,

  /**The current value of the input, which should be maintained by the parent elemen through utilizing the onChange callback. */
  value: _propTypes["default"].string,

  /**An object of error requirements for the input field. Possible error requirements are 'symbol' (boolean), 'uppdercase' (boolean) and 'length' (number). */
  errorRequirements: _propTypes["default"].object,

  /**Styling applied to the error area of the text field */
  errorStyle: _propTypes["default"].object,

  /**Content to be displayed before the text in the field */
  prefix: _propTypes["default"].node,

  /**Content to be displayed after the text in the field */
  postfix: _propTypes["default"].node,

  /**Enables the suggestion box to be shown */
  showSuggestions: _propTypes["default"].bool,

  /**The data that populates the suggestion box. */
  suggestionData: _propTypes["default"].array,

  /**The value passed to the inputs 'autoComplete' prop */
  autoComplete: _propTypes["default"].string
};
TextField.defaultProps = {
  style: {},
  className: '',
  type: 'inputs',
  elementType: 'input',
  value: '',
  placeholder: null,
  error: null,
  inputType: 'text',
  maxLength: null,
  name: null,
  onClick: function onClick() {
    return false;
  },
  onBlur: function onBlur() {
    return false;
  },
  onKeyUp: function onKeyUp() {
    return false;
  },
  onKeyPress: function onKeyPress() {
    return false;
  },
  onEnterKey: function onEnterKey() {
    return false;
  },
  onChange: function onChange() {
    return false;
  },
  postfix: null,
  prefix: null,
  disabled: false,
  readOnly: false,
  showSuggestions: false,
  suggestionData: [],
  label: null,
  iconName: null,
  iconColor: null,
  iconPosition: null,
  errorRequirements: {},
  errorStyle: {},
  autoComplete: ''
};